import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import FullPageLoader from './components/Common/FullPageLoader'
import {setupAuthentication, ensureIsAuthorized} from './auth'

const rootElement = document.getElementById('root')
ReactDOM.render(<FullPageLoader />, rootElement)

setupAuthentication()

const renderApp = async () => {
  await ensureIsAuthorized()

  ReactDOM.render(<App />, rootElement)
}

renderApp()
